import { useEffect, useState } from 'react';
import BreadCrumbWrapper from 'components/global/BreadCrumbs/BreadCrumbs';
import Funds from 'components/global/Funds';
import { fundsSignals } from 'components/global/Funds/Funds.signals';
import { useLocation } from 'react-router-dom';
import { canPerformAction } from '../../../../../libs/programAccessPermissions';
import userAccountSignal from '../../../../../signals/UserAccount.signal';
import api from '../../../../../api/api';
import loaderSignal from '../../../../../signals/Loader.signal';

const EdoVcProgramMembershipDetail = () => {
  const location = useLocation();
  const segments = location.pathname.split('/');
  const [canViewMaintenance, setCanViewMaintenance] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  let labels = [];
  const { fundingProgramMembership } = fundsSignals.value;
  if (!!fundingProgramMembership) {
    const { ventureCapitalFirm, fundingProgram } = fundingProgramMembership;
    if (location.pathname.includes('programs')) {
      labels = [
        '',
        !!fundingProgram ? fundingProgram.name : '',
        !!fundingProgram ? `Funds in ${fundingProgram.name}` : '',
      ];
    } else {
      labels = [
        segments[2] === 'vc' ? 'Venture Capitalists' : '',
        !!ventureCapitalFirm ? ventureCapitalFirm.name : '',
        !!fundingProgram ? `Funds in ${fundingProgram.name}` : '',
      ];
    }
  }

  // Check if user has canViewMaintenance permission on any program
  useEffect(() => {
    const checkViewMaintenancePermission = async () => {
      try {
        loaderSignal.update({ isContentLoading: true });
        // Fetch funding programs for the EDO
        const fundingPrograms = await api.get({
          path: '/fundingPrograms',
          options: {
            where: {
              edoId: userAccountSignal.value.userData?.account.edoId,
            },
          },
        });

        if (!fundingPrograms || fundingPrograms.length === 0) {
          setCanViewMaintenance(false);
          setIsChecking(false);
          return;
        }

        // Check if user has canViewMaintenance permission on any program
        const viewChecks = await Promise.all(
          fundingPrograms.map((program) =>
            canPerformAction(program.id, 'canViewMaintenance')
          )
        );

        setCanViewMaintenance(viewChecks.some((hasPermission) => hasPermission));
      } catch (error) {
        console.error('Error checking view maintenance permission:', error);
        setCanViewMaintenance(false);
      } finally {
        setIsChecking(false);
        loaderSignal.reset();
      }
    };

    checkViewMaintenancePermission();
  }, []);

  if (isChecking) {
    return (
      <BreadCrumbWrapper labels={labels}>
        <div className="border border-gray shadow-sm bg-white p-40">
          <p className="text-center">Loading...</p>
        </div>
      </BreadCrumbWrapper>
    );
  }

  if (!canViewMaintenance) {
    return (
      <BreadCrumbWrapper labels={labels}>
        <div className="border border-gray shadow-sm bg-white p-40">
          <h3 className="text-center">Access Denied</h3>
          <p className="text-center">
            You do not have permission to view program membership details.
          </p>
        </div>
      </BreadCrumbWrapper>
    );
  }

  return (
    <BreadCrumbWrapper labels={labels}>
      <Funds />
    </BreadCrumbWrapper>
  );
};

export default EdoVcProgramMembershipDetail;
